import { get } from '@/services/awsAmplify'

import { Badge, FollowStatus } from '@enums'
import { ISearchQuery } from '@/interfaces'

export interface IUser {
  displayName?: string
  avatar?: string
  username: string
  id: string
  followStatus: FollowStatus
  avatarUrl?: string
  userId?: UUID
  isModerator?: boolean
  isAmbassador?: boolean
  badge?: Badge
}

export type GetFindUsersResult = {
  users: IUser[]
  lastKey?: string
  pages?: []
}

export const getFindUsers = async (
  query: ISearchQuery,
  pageParam: string
): Promise<GetFindUsersResult> => {
  let q = query.q
  if (query.q.length < 2) {
    q = ''
  }

  const params = Object.assign({ q }, pageParam ? { startAt: pageParam } : {})

  const result = await get({
    path: '/profile',
    params,
  })

  return {
    users: (result?.users || []) as IUser[],
    lastKey: (result?.lastKey as string) || undefined,
  }
}
